module.exports = __webpack_public_path__ + "static/img/icon_jilu.99796223.png";